export const DRAFT_INLINE_STYLE_FONT_WEIGHT_BOLD = 'BOLD';
export const DRAFT_INLINE_STYLE_FONT_STYLE_ITALIC = 'ITALIC';
export const DRAFT_INLINE_STYLE_TEXT_TRANSFORM_UNDERLINE = 'UNDERLINE';
